import { useEffect, useState, useRef } from 'react';
import {
  DRAWER_CLOSE_TIME,
  DRAWER_DELAY_OPACITY_TRANSITION_AFTER_CLOSE_TIME,
  DRAWER_OPEN_TIME,
} from '../utils';

const useOpeningAnimation = (isOpen: boolean, duration: number) => {
  const [opacity, setOpacity] = useState(0);
  const animationFrameRef = useRef<number | null>(null);

  useEffect(() => {
    if (isOpen) {
      const startTime = Date.now();

      const animateOpening = () => {
        const elapsedTime = Date.now() - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        setOpacity(progress);

        if (progress < 1) {
          animationFrameRef.current = requestAnimationFrame(animateOpening);
        }
      };

      animationFrameRef.current = requestAnimationFrame(animateOpening);
    } else {
      setOpacity(0);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [isOpen, duration]);

  return opacity;
};

const useDrawerOpenClose = ({
  handleManualClose,
  isOpen,
}: {
  isOpen: boolean;
  handleManualClose: () => void;
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isOpacityTransitionActive, setIsOpacityTransitionActive] =
    useState(false);
  // const openingOpacity = useOpeningAnimation(isOpen, DRAWER_OPEN_TIME);

  const setDrawerToClose = () => {
    setIsDrawerOpen(false);

    setTimeout(() => {
      setIsOpacityTransitionActive(true);
    }, DRAWER_DELAY_OPACITY_TRANSITION_AFTER_CLOSE_TIME);

    setTimeout(() => {
      handleManualClose();
    }, DRAWER_CLOSE_TIME);
  };

  useEffect(() => {
    if (isOpen) {
      setIsDrawerOpen(true);
      setIsOpacityTransitionActive(false);
    } else {
      setDrawerToClose();
    }
  }, [isOpen]);

  // const drawerOpacity = isOpacityTransitionActive ? 0 : openingOpacity;
  const drawerOpacity = isOpacityTransitionActive ? 0 : 1;

  return {
    isDrawerOpen,
    setDrawerToClose,
    drawerOpacity,
  };
};

export default useDrawerOpenClose;
